var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contact-bubble"}},[_c('button',{staticClass:"circle",on:{"click":function($event){_vm.openModal()}}},[_c('i',{staticClass:"fa fa-commenting fa-3x",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('contactModal',{attrs:{"activate":_vm.addActive},on:{"closeRequest":_vm.close}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2ffacfa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contactBubble.vue
// module id = null
// module chunks = 